// dev config
export default {
    env: 'dev',
    version: process.env.version
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/env/dev.ts